export const VIEWS = {
  CHART: 'Chart',
  TABLE: 'Table',
} as const;

export const DISPLAY_TAB = {
  MATURITY: 'Maturity',
  DURATION: 'Duration',
} as const;

export const Constants = {
  TAG_NAME: 'pop-maturity-and-duration-component',
  COMPONENT_TITLE: 'Maturity and duration',
  MATURITY_TAB_LABEL: 'Maturity',
  DURATION_TAB_LABEL: 'Duration',
  DATA_AS_OF_DROPDOWN_LABEL: 'Data as of',
  DATA_AS_OF_DROPDOWN_ID: 'maturity-and-duration-data-as-of-select',
  VIEW_DROPDOWN_LABEL: 'View',
  VIEW_DROPDOWN_ID: 'maturity-and-duration-view-select',
  MATURITY_UNAVAILABLE: 'Maturity unavailable',
  DURATION_UNAVAILABLE: 'Duration unavailable',
  VIEWS: [VIEWS.CHART, VIEWS.TABLE],
  DEFAULT_VIEW: VIEWS.CHART,
  TABS: [DISPLAY_TAB.MATURITY, DISPLAY_TAB.DURATION],
  DEFAULT_TAB: DISPLAY_TAB.MATURITY,
} as const;
